import { CognitoUser } from '@cco/model';
import { createAction, props, union } from '@ngrx/store';

export const CheckAuthenticationStatus = createAction(
  '[Auth2] CHECK_AUTH_STATUS',
  props<{ redirectUrl?: string }>(),
);
export const CheckAuthenticationStatusSuccess = createAction(
  '[Auth2] CHECK_AUTH_STATUS_SUCCESS',
  props<{ currentUser: CognitoUser; redirectUrl: string }>(),
);
export const CheckAuthenticationStatusTimeout = createAction(
  '[Auth2] CHECK_AUTH_STATUS_TIMEOUT',
  props<{ redirectUrl?: string }>(),
);
export const CheckAuthenticationStatusFailure = createAction(
  '[Auth2] CHECK_AUTH_STATUS_FAILURE',
  props<{ error: any }>(),
);
export const PingAuthenticationStatus = createAction('[Auth2] PING_AUTHENTICATION_STATUS');
export const PingAuthenticationStatusSuccess = createAction(
  '[Auth2] PING_AUTHENTICATION_STATUS_SUCCESS',
  props<{ currentUser: CognitoUser }>(),
);
export const AuthenticateUser = createAction('[Auth2] AUTHENTICATE_USER');
export const AuthenticateUserSuccess = createAction('[Auth2] AUTHENTICATE_USER_SUCCESS');
export const AuthenticateUserFailure = createAction(
  '[Auth2] AUTHENTICATE_USER_FAILURE',
  props<{ error: any }>(),
);
export const AuthNullAction = createAction('[Auth2] AUTH_NULL_ACTION');
export const Logout = createAction('[Auth2] LOGOUT');
export const RemoteLogout = createAction('[Auth2] REMOTE_LOGOUT');
// export const LogoutSuccess = createAction('[Auth2] LOGOUT_SUCCESS');
export const BeginOAuth2LoginProcess = createAction(
  '[Auth2] BEGIN_OAUTH2_LOGIN_PROCESS',
  props<{ tenantCode: string; rememberMe: boolean }>(),
);
export const BeginOAuth2LoginProcessSuccess = createAction(
  '[Auth2] BEGIN_OAUTH2_LOGIN_PROCESS_SUCCESS',
);
export const BeginOAuth2LoginProcessFailure = createAction(
  '[Auth2] BEGIN_OAUTH2_LOGIN_PROCESS_FAILURE',
  props<{ error: any }>(),
);

export const Auth2Actions = union({
  CheckAuthenticationStatus,
  CheckAuthenticationStatusSuccess,
  CheckAuthneticationStatusTimeout: CheckAuthenticationStatusTimeout,
  CheckAuthenticationStatusFailure,
  PingAuthenticationStatus,
  PingAuthenticationStatusSuccess,
  AuthenticateUser,
  AuthenticateUserSuccess,
  AuthenticateUserFailure,
  AuthNullAction,
  Logout,
  RemoteLogout, // LogoutSuccess,
  BeginOAuth2LoginProcess,
  BeginOAuth2LoginProcessSuccess,
  BeginOAuth2LoginProcessFailure,
});
